import React, { Component, useEffect, useRef, useState } from "react";
import ReactPaginate from "react-paginate";
import ReactTooltip from "react-tooltip";
import Highlighter from "react-highlight-words";
import {
    popBreadCrumpData,
    findPrevPathFromBreadCrumpData,
    checkPermission,
    popBreadCrumpOnPageClose,
    removeAllTags,
    showAlert as showAlertUtil
} from "../../../config/utils";
import actions from "../actions";
import history from "../../../config/history";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import moment from "moment";
import MobileAction from "../../mobileRecommendation/actions";
import { ERROR_COPY } from "../../../config/errorMessages";

const EditHistory = ({
    closeHistory,
    editSurvey,
    deleteSurveyTemplate,
    surveyProjectId,
    isSurveyAsset,
    isMobileRecommendation = false,
    restoreLog,
    isSurveyProject = false,
    remoteId,
    isMobileLog = false,
    isFCASurveyProject = false,
    refresh = false,
    resetRefresh,
    isRestore = false,
    hasEdit = false,
    hasDelete = false,
    hasVerificationLogs = false,
    changeToVerificationHistory,
    isVerificationSurvey,
    isFCASurvey = false,
    surveyTemplateId = false
}) => {
    const [searchValue, setSearchValue] = useState("");
    const [logData, setLogData] = useState([]);
    const { getDataLogsResponse, restoreDataLogsResponse } = useSelector(state => state?.assetSurveyProjectReducer);
    // const { getMobileRecomDataLogsResponse, restoreMobileRecomDataLogsResponse } = useSelector(state => state?.mobileRecommendationsReducer);
    const dispatch = useDispatch();
    const { tab = "" } = useParams();
    const queryParam = useParams();
    const [params, setParams] = useState({ limit: 40, offset: 0, search: "", filters: null, filterKeys: null, list: null, order: null });
    let userRole = localStorage.getItem("role");
    const [paginationParams, setPaginationParams] = useState({
        totalPages: 0,
        perPage: 40,
        currentPage: 0,
        totalCount: 0
    });
    const restore_ref = useRef(null);
    const [alertMessage, setAlertMessage] = useState("");
    const { restoreMobileRecomDataLogsResponse } = useSelector(state => state?.mobileRecommendationsReducer);
    const [toggleBtn, setToggleBtn] = useState(false);
    const fromValueStyle = {
        backgroundColor: "#ffe6e6",
        padding: "4px",
        borderRadius: "3px",
        display: "inline-block",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        marginBottom: "5px"
    };

    const toValueStyle = {
        backgroundColor: "#e6ffe6",
        padding: "4px",
        borderRadius: "3px",
        display: "inline-block",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word"
    };
    useEffect(() => {
        return () => {
            dispatch(actions.resetDataLog());
        };
    }, []);

    useEffect(() => {
        dispatch(actions.resetDataLog());
        setLogData([]);
        setPaginationParams({ totalPages: 0, perPage: 40, currentPage: 0, totalCount: 0 });
    }, [queryParam?.id, surveyTemplateId]);

    useEffect(() => {
        refreshHistoryData();
    }, [params, toggleBtn, remoteId, surveyTemplateId, surveyProjectId]);

    useEffect(() => {
        if (refresh) {
            refreshHistoryData();
            resetRefresh(false);
        }
    }, [refresh]);

    useEffect(() => {
        if (getDataLogsResponse?.success) {
            setLogData(getDataLogsResponse?.activity_log);
            setPaginationParams(prevPaginationParams => ({
                ...prevPaginationParams,
                totalCount: getDataLogsResponse?.count,
                totalPages: Math.ceil(getDataLogsResponse?.count / prevPaginationParams.perPage)
            }));
        }
    }, [getDataLogsResponse]);

    useEffect(() => {
        if (
            restore_ref?.current &&
            ((!restoreDataLogsResponse?.loading && !isMobileRecommendation) ||
                (!restoreMobileRecomDataLogsResponse?.loading && isMobileRecommendation))
        ) {
            restore_ref.current = false;
            const { success, error, detail = null } = isMobileRecommendation ? restoreMobileRecomDataLogsResponse : restoreDataLogsResponse;
            if (success) {
                refreshHistoryData();
            } else if (error) {
                setAlertMessage(typeof detail === "string" ? detail : ERROR_COPY.GENERIC);
            }
        }
    }, [restoreDataLogsResponse, restoreMobileRecomDataLogsResponse]);

    useEffect(() => {
        alertMessage && showAlert();
    }, [alertMessage]);

    const showAlert = () => {
        showAlertUtil(alertMessage);
        setTimeout(() => setAlertMessage(""), 3000);
    };
    const refreshHistoryData = () => {
        let paramDetails = {
            ...params,
            offset: params?.offset + 1,
            filters: {
                [toggleBtn ? "mobile_logs.asset_survey_project_id" : "versions.asset_survey_project_id"]: {
                    filters: ["string_equals"],
                    key: surveyProjectId
                }
            }
        };

        if (isSurveyProject && !isMobileLog) {
            paramDetails.block_event = "ASSET_MODIFIED_MULTIEDIT";
        }

        if (isSurveyAsset || isMobileRecommendation || isFCASurveyProject || hasVerificationLogs || isFCASurvey) {
            paramDetails.filters = {
                [toggleBtn || hasVerificationLogs
                    ? isFCASurveyProject || isFCASurvey
                        ? "mobile_logs.form_id"
                        : "mobile_logs.item_id"
                    : "versions.item_id"]: {
                    filters: ["string_equals"],
                    key: toggleBtn && !isFCASurveyProject && !isFCASurvey ? remoteId : isFCASurvey && toggleBtn ? surveyTemplateId : surveyProjectId
                }
            };
        }

        if (hasVerificationLogs)
            paramDetails.filters = {
                ...(paramDetails?.filters ?? {}),
                "mobile_logs.item_type": {
                    filters: ["string_equals"],
                    key: "ASSET_VERIFICATION_SURVEY"
                }
            };
        if (userRole !== "super_admin") {
            paramDetails = {
                ...paramDetails,
                filters: {
                    ...paramDetails?.filters,
                    [toggleBtn || hasVerificationLogs ? "mobile_logs.whodunnit_id" : "versions.whodunnit"]: {
                        filters: ["string_equals"],
                        key: localStorage.getItem("userId")
                    }
                }
            };
        }
        dispatch(actions?.getAllDataLogs(paramDetails, toggleBtn || hasVerificationLogs));
    };
    const searchHandler = async e => {
        e?.preventDefault && e.preventDefault();
        setParams({ ...params, search: e.target.value, offset: 0 });

        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            currentPage: 0
        }));
    };
    const handlePerPageChange = async e => {
        const newPerPage = e.target.value;
        setParams(prevParams => ({
            ...prevParams,
            offset: 0,
            limit: newPerPage
        }));
        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            perPage: newPerPage,
            currentPage: 0
        }));
    };

    const handlePageClick = async page => {
        setParams(prevParams => ({
            ...prevParams,
            offset: page.selected
        }));
        setPaginationParams(prevPaginationParams => ({
            ...prevPaginationParams,
            currentPage: page.selected
        }));
    };
    const safeParseJSON = jsonString => {
        try {
            return JSON.parse(
                jsonString

                    ?.replace(/'/g, '"')
                    .replace(/\bTrue\b/g, "true")
                    .replace(/\bFalse\b/g, "false")
            );
        } catch (e) {}

        // ---- 2️⃣ Second attempt: Python-dict-style to JSON ----
        try {
            let s = jsonString
                .replace(/\bTrue\b/g, "true")
                .replace(/\bFalse\b/g, "false")
                .replace(/\bNone\b/g, "null")
                // Replace ONLY single-quoted string literals safely
                .replace(/'([^'\\]*(?:\\.[^'\\]*)*)'/g, (_, content) => {
                    // unescape \' → '
                    content = content.replace(/\\'/g, "'");
                    // escape " for JSON
                    content = content.replace(/"/g, '\\"');
                    return `"${content}"`;
                });

            return JSON.parse(s);
        } catch (e) {
            return null;
        }
    };
    const buildSentence = ({ label, code, old, new: newValue, whodunnitName, notes, event }) => {
        const formattedLabel = label;
        const formattedCode = code;
        const formattedOld = old || "null";
        const formattedNew = newValue || "null";
        const formattedWhodunnitName = whodunnitName;
        const formattedNotes = notes;

        switch (event) {
            case "ASSET__ADD_ASSET":
                return `Asset ${formattedNotes} added ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}.`;
            case "ASSET__UPDATE_ASSET":
                return `Asset ${formattedNotes} modified ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}.`;
            case "ASSET__SYNC_SUCCESS":
                return `Asset ${formattedNotes} synced successfully ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}.`;
            case "ASSET__SYNC_FAILED":
                return `Asset ${formattedNotes} sync failed for ${formattedWhodunnitName}.`;
            case "SURVEY_FORM__DOWNLOAD_SURVEY_START":
                return `${formattedWhodunnitName} started downloading the survey form ${formattedNotes}.`;
            case "SURVEY_FORM__DOWNLOAD_IMAGE_START":
                return `${formattedWhodunnitName} started downloading the image(s) of ${formattedNotes}.`;
            case "SURVEY_FORM__DOWNLOAD_SURVEY_SUCCESS":
                return `Survey form ${formattedNotes} downloaded successfully ${
                    formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""
                }.`;
            case "SURVEY_FORM__DOWNLOAD_IMAGE_SUCCESS":
                return `Image(s) of ${formattedNotes} downloaded successfully ${
                    formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""
                }.`;
            case "SURVEY_FORM__DOWNLOAD_SURVEY_FAIL":
                return `Survey form ${formattedNotes} download failed ${formattedWhodunnitName !== "null" ? `for ${formattedWhodunnitName}` : ""}.`;
            case "SURVEY_FORM__DOWNLOAD_IMAGE_FAIL":
                return `Image(s) of ${formattedNotes} download failed ${formattedWhodunnitName !== "null" ? `for ${formattedWhodunnitName}` : ""}.`;
            case "SURVEY_FORM__SYNC_SURVEY_START":
                return `${formattedWhodunnitName} started syncing the survey form ${formattedNotes}.`;
            case "SURVEY_FORM__SYNC_SURVEY_SUCCESS":
            case "RECOMMENDATION__SYNC_SUCCESS":
                return `${event === "RECOMMENDATION__SYNC_SUCCESS" ? "Recommendation" : "Survey"} form ${formattedNotes} synced successfully ${
                    formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""
                }.`;
            case "RECOMMENDATION__SYNC_FAILED":
            case "SURVEY_FORM__SYNC_SURVEY_FAIL":
                return `${event === "RECOMMENDATION__SYNC_FAILED" ? "Recommendation" : "Survey"} form ${formattedNotes} sync failed ${
                    formattedWhodunnitName !== "null" ? `for ${formattedWhodunnitName}` : ""
                }.`;
            case "ASSET_MODIFIED":
            case "ASSET_MODIFIED_RESTORE":
            case "INA_MOB_MODIFIED_RESTORE":
            case "SURVEY_RECOMMENDATIONS_MODIFIED":
            case "SURVEY_RECOMMENDATIONS_MODIFIED_RESTORE":
            case "SURVEY_RECOMMENDATIONS_MULTIEDIT":
            case "RECOMMENDATION__DOWNLOAD_SURVEY_SUCCESS":
            case "RECOMMENDATION__DOWNLOAD_SURVEY_FAIL":
            case "RECOMMENDATION_STATUS_UPDATES":
            case "Restore":
                return `${formattedLabel ? `${formattedLabel} of` : ""} ${formattedCode} changed from ${formattedOld} to ${formattedNew} ${
                    formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""
                }`;
            case "ASSET_SYNCED_COUNT":
                return `${formattedNotes} ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}`;
            case "ASSET_MODIFIED_MULTIEDIT":
                return `Assets ${formattedCode} ${formattedWhodunnitName !== "null" ? `were group edited by ${formattedWhodunnitName}` : ""}.`;
            case "RESTORED":
            case "SURVEY_STATUS_CHANGE":
                return `${formattedLabel} of ${formattedCode} changed from ${formattedOld} to ${formattedNew} ${
                    formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""
                }`;

            case "STARTING_SYNCING_ASSET":
            case "GROUP_ASSET_SYNC_CLICK":
            case "SINGLE_ASSET_SYNC_CLICK":
            case "STARTING_SYNCING_RECOMMENDATION":
            case "SINGLE_RECOMMENDATION_SYNC_CLICK":
                return `${
                    event === "STARTING_SYNCING_RECOMMENDATION" || event === "SINGLE_RECOMMENDATION_SYNC_CLICK" ? "Recommendation" : "Asset"
                } ${formattedNotes} ${event === "GROUP_ASSET_SYNC_CLICK" ? "group" : ""} syncing initiated ${
                    formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""
                }`;
            case "IMAGE_ZIP_UPLOADING":
                return `${formattedNotes} image zip uploading ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}`;
            case "VIEW_ASSET":
            case "DELETE_ASSET":
            case "VIEW_RECOMMENDATION":
            case "DELETE_RECOMMENDATION":
                return `${event === "DELETE_RECOMMENDATION" || event === "VIEW_RECOMMENDATION" ? "Recommendation" : "Asset"} ${formattedNotes} ${
                    event === "VIEW_ASSET" || event === "VIEW_RECOMMENDATION" ? "viewed" : "deleted"
                } ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}`;
            case "ASSET_IMAGE_DELETED":
            case "RECOMMENDATION_IMAGE_DELETED":
                return `${formattedLabel} ${formattedOld} from ${formattedCode} was deleted ${
                    formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""
                }`;
            case "ASSIGNED_SURVEYOR":
                return `${formattedNew}  was assigned ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}`;
            case "UNASSIGNED_SURVEYOR":
                return `${formattedNew}  was unassigned ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}`;
            case "REASSIGNED_SURVEYOR":
                return `${formattedNew}  was reassigned ${formattedWhodunnitName !== "null" ? `by ${formattedWhodunnitName}` : ""}`;

            default:
                return "";
        }
    };

    const renderSentence = (item, searchValue, key = null) => {
        const parsedSentence = item?.notes && safeParseJSON(item?.notes);
        if (parsedSentence?.code && item?.event === "ASSET_MODIFIED_MULTIEDIT") {
            parsedSentence.code = (parsedSentence?.code ?? [])?.reduce((acc, item) => {
                acc = acc ? `${acc}, ${item}` : item;
                return acc;
            }, "");
        }
        const templates = buildSentence({
            label: parsedSentence?.label || null,
            code: parsedSentence?.code,
            old: key ? parsedSentence?.old?.[key] : parsedSentence?.old,
            new: key ? parsedSentence?.new?.[key] : parsedSentence?.new,
            whodunnitName: item?.whodunnit_name,
            notes: item?.notes,
            event: item?.event
        });
        const splitAtKeyword = (sentence, keyword) => {
            const index = sentence?.indexOf(keyword);
            if (index !== -1) {
                return [sentence?.slice(0, index), sentence?.slice(index + keyword?.length)];
            }
            return [sentence, ""];
        };
        const sentence = templates ?? "";
        const [beforeNotes, afterNotes] = splitAtKeyword(sentence, item?.notes || "");
        const [beforeName, afterName] = splitAtKeyword(afterNotes, item?.whodunnit_name || "");
        const [beforeLabel, afterLabel] = splitAtKeyword(sentence, parsedSentence?.label || "");
        const [beforeCode, afterCode] = splitAtKeyword(
            item?.event !== "RECOMMENDATION_STATUS_UPDATES" && item?.event !== "Restore" ? afterLabel : sentence,
            parsedSentence?.code || ""
        );
        const [beforeOld, afterOld] = splitAtKeyword(afterCode, key ? parsedSentence?.old?.[key] : parsedSentence?.old || "null");
        const [beforeNew, afterNew] = splitAtKeyword(afterOld, key ? parsedSentence?.new?.[key] : parsedSentence?.new || "null");
        const [beforeWhodunnit, afterWhodunnit] = splitAtKeyword(afterNew, item?.whodunnit_name);
        return item.event === "ASSET_MODIFIED_MULTIEDIT" || item.event === "ASSET_IMAGE_DELETED" ? (
            <li>
                {item.event === "ASSET_MODIFIED_MULTIEDIT" ? (
                    <span>
                        Assets{" "}
                        <b>
                            <Highlighter searchWords={[params?.search]} textToHighlight={parsedSentence?.code} />
                        </b>
                    </span>
                ) : (
                    <span>
                        <b>
                            <Highlighter searchWords={[params?.search]} textToHighlight={parsedSentence?.old} />
                        </b>{" "}
                        from{" "}
                        <b>
                            <Highlighter searchWords={[params?.search]} textToHighlight={parsedSentence?.code} />
                        </b>
                    </span>
                )}
                {item?.whodunnit_name && (
                    <span>
                        {beforeWhodunnit || (item.event === "ASSET_MODIFIED_MULTIEDIT" ? "was group edited by " : "was deleted by ")}{" "}
                        <b>
                            <Highlighter searchWords={[searchValue]} textToHighlight={item?.whodunnit_name} />
                        </b>
                    </span>
                )}
                .
            </li>
        ) : item?.event === "ASSIGNED_SURVEYOR" || item?.event === "UNASSIGNED_SURVEYOR" || item?.event === "REASSIGNED_SURVEYOR" ? (
            <li>
                <b>
                    <Highlighter searchWords={[searchValue]} textToHighlight={parsedSentence?.new ?? ""} />
                </b>{" "}
                was {item?.event === "ASSIGNED_SURVEYOR" ? "assigned" : item?.event === "UNASSIGNED_SURVEYOR" ? "unassigned" : "reassigned"} by{" "}
                <b>
                    <Highlighter searchWords={[searchValue]} textToHighlight={item?.whodunnit_name ?? ""} />
                </b>
            </li>
        ) : item?.event === "update" ? (
            <li>
                Asset{" "}
                <b>
                    <Highlighter searchWords={[params?.search]} textToHighlight={parsedSentence?.code} />{" "}
                </b>
                has been {parsedSentence?.old ? "unlocked " : "locked "}
                <b>
                    <Highlighter
                        searchWords={[params?.search]}
                        textToHighlight={
                            item?.event !== "SURVEY_FORM__DOWNLOAD_SURVEY_START" &&
                            item?.event !== "SURVEY_FORM__DOWNLOAD_IMAGE_START" &&
                            item.whodunnit_name
                        }
                    />
                </b>
                {afterName}
            </li>
        ) : item.event !== "ASSET_MODIFIED_RESTORE" &&
          item?.event !== "INA_MOB_MODIFIED_RESTORE" &&
          item?.event !== "ASSET_MODIFIED" &&
          item?.event !== "SURVEY_RECOMMENDATIONS_MODIFIED_RESTORE" &&
          item?.event !== "SURVEY_RECOMMENDATIONS_MODIFIED" &&
          item?.event !== "RESTORED" &&
          item.event !== "SURVEY_RECOMMENDATIONS_MULTIEDIT" &&
          item?.event !== "RECOMMENDATION_STATUS_UPDATES" &&
          item?.event !== "Restore" &&
          item?.event !== "SURVEY_STATUS_CHANGE" ? (
            <li>
                {item?.event === "SURVEY_FORM__DOWNLOAD_SURVEY_START" || item?.event === "SURVEY_FORM__DOWNLOAD_IMAGE_START" ? (
                    <>
                        <b>
                            <Highlighter searchWords={[params?.search]} textToHighlight={item?.whodunnit_name} />
                        </b>
                        {splitAtKeyword(beforeNotes, item?.whodunnit_name || "")?.[1]}
                    </>
                ) : (
                    beforeNotes
                )}
                <b>
                    <Highlighter searchWords={[params?.search]} textToHighlight={item.notes} />
                </b>
                {beforeName ? beforeName : " by "}
                <b>
                    <Highlighter
                        searchWords={[params?.search]}
                        textToHighlight={
                            item?.event !== "SURVEY_FORM__DOWNLOAD_SURVEY_START" &&
                            item?.event !== "SURVEY_FORM__DOWNLOAD_IMAGE_START" &&
                            item.whodunnit_name
                        }
                    />
                </b>
                {afterName}
            </li>
        ) : (
            <li>
                <b>
                    <Highlighter
                        searchWords={[searchValue]}
                        textToHighlight={item?.event === "SURVEY_STATUS_CHANGE" ? "Survey project status" : (parsedSentence?.label ?? "")}
                    />
                </b>
                {beforeCode}
                <b>
                    <Highlighter searchWords={[searchValue]} textToHighlight={parsedSentence?.code ?? ""} />
                </b>
                {beforeOld}
                <span style={fromValueStyle}>
                    <Highlighter
                        searchWords={[searchValue]}
                        textToHighlight={key ? removeAllTags(parsedSentence?.old?.[key] ?? "") : removeAllTags(parsedSentence?.old) || "null"}
                    />
                </span>
                <span>{beforeNew ? beforeNew : "changed to "}</span>
                <span style={toValueStyle}>
                    <Highlighter
                        searchWords={[searchValue]}
                        textToHighlight={key ? removeAllTags(parsedSentence?.new?.[key]) : removeAllTags(parsedSentence?.new) || "null"}
                    />
                </span>

                {item?.whodunnit_name ? (beforeWhodunnit ? item?.newValue || beforeWhodunnit : " by ") : ""}
                {item?.whodunnit_name && (
                    <>
                        <b>
                            <Highlighter searchWords={[searchValue]} textToHighlight={item?.whodunnit_name ?? ""} />
                        </b>
                    </>
                )}
                {parsedSentence?.source && (
                    <span>
                        {" "}
                        via <Highlighter searchWords={[searchValue]} textToHighlight={String(parsedSentence.source)} />
                    </span>
                )}
            </li>
        );
    };
    const hasRestore = item => {
        if (!isRestore) return false;
        if (
            ((item.event === "ASSET_MODIFIED_RESTORE" || item.event === "RESTORED" || item.event === "SURVEY_RECOMMENDATIONS_MODIFIED_RESTORE") &&
                (isMobileRecommendation
                    ? checkPermission("logs", "mobile_recommendations", "restore")
                    : checkPermission("logs", "mobile_assets", "restore"))) ||
            item?.event === "RECOMMENDATION_STATUS_UPDATES" ||
            item?.event === "Restore"
        ) {
            return true;
        } else return false;
    };

    const showActionColumn = (isSurveyAsset || isMobileRecommendation) && isRestore && !toggleBtn;

    const renderBoldText = text => <b>{text}</b>;

    const parseChangeSentence = str => {
        if (!str) return null;

        const clean = val => {
            const trimmed = val?.trim();
            return trimmed === "" || trimmed?.toLowerCase() === "null" ? null : trimmed;
        };

        const match = str.match(/(.*?): \[\[from\]\]\s*(.*?)\s*\[\[to\]\]\s*(.*)/i);

        if (!match) return null;

        const [, field, beforeRaw, afterRaw] = match;

        return {
            field: clean(field),
            before: clean(beforeRaw),
            after: clean(afterRaw)
        };
    };
    const changeSentence = (data, search) => {
        const parsed = parseChangeSentence(data);
        if (!parsed) return null;

        return (
            <span style={{ display: "block", marginBottom: 4 }}>
                <strong>
                    <Highlighter searchWords={[search]} textToHighlight={parsed?.field} />
                </strong>
                : from{" "}
                <strong>
                    <Highlighter searchWords={[search]} textToHighlight={parsed?.before || "null"} />
                </strong>{" "}
                to{" "}
                <strong>
                    <Highlighter searchWords={[search]} textToHighlight={parsed?.after || "null"} />
                </strong>
            </span>
        );
    };
    const checklistChanges = (item, searchValue) => {
        const parsedNotes = safeParseJSON(item?.notes);

        if (!parsedNotes) return null;

        const code = parsedNotes?.code ?? "";
        const who = item?.whodunnit_name ?? "";

        return (
            <div>
                <div style={{ fontSize: 14 }}>
                    Checklist of{" "}
                    <strong>
                        <Highlighter searchWords={[searchValue]} textToHighlight={code || "null"} />
                    </strong>{" "}
                    changed by{" "}
                    <strong>
                        <Highlighter searchWords={[searchValue]} textToHighlight={who || "null"} />
                    </strong>
                </div>

                <ul>
                    {safeParseJSON(item?.notes)?.change?.map((chg, idx) => {
                        const itemKey = Object.keys(chg || {})?.[0];
                        const changes = chg?.[itemKey];

                        return (
                            <li key={idx} className="mobile-log-list">
                                <strong>Item {itemKey?.replace("Item", "")?.trim()}</strong>
                                <ul>
                                    {(changes ?? [])?.map((line, index) => (
                                        <li key={index} className="mobile-log-list">
                                            {changeSentence(line, searchValue)}
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    const renderSplitText = text => {
        if (!text || typeof text !== "string") return null;

        if (text?.includes("changed from") && text?.includes(" to ")) {
            const prefix = text?.slice(0, text?.indexOf("changed from"))?.trim();
            const changeText = text?.slice(text?.indexOf("changed from"))?.trim();

            const match = changeText.match(/changed from (.*?) to (.*)$/);

            if (match) {
                const [, oldValueRaw, newValueRaw] = match || {};
                const oldValue = oldValueRaw ?? "";
                const newValue = newValueRaw ?? "";

                return (
                    <span>
                        <span>{prefix} </span>
                        <span>changed from </span>
                        <span style={fromValueStyle}>{oldValue}</span>
                        <span> to </span>
                        <span style={toValueStyle}>{newValue}</span>
                    </span>
                );
            }
            return <span>{text}</span>;
        }

        return <span>{text}</span>;
    };

    return (
        <React.Fragment>
            <div className="tab-active">
                {(!isFCASurveyProject || isFCASurvey) && (
                    <div className="otr-edit-delte col-md-12 text-right">
                        {hasVerificationLogs && (
                            <span class="edit-icn-bx">
                                <label class="name-label mr-2">Verification Survey Logs</label>
                                <label
                                    class="switch toggle-switch mr-2"
                                    data-tip=""
                                    data-effect="solid"
                                    data-place="bottom"
                                    data-for="table-row1079f3b2-e33b-4273-9679-38566601b9c1"
                                    currentitem="false"
                                >
                                    <input
                                        type="checkbox"
                                        onChange={() => {
                                            changeToVerificationHistory();
                                        }}
                                        checked={isVerificationSurvey}
                                    />
                                    <span class="slider round"></span>
                                </label>
                            </span>
                        )}
                        <span class="edit-icn-bx" type="button" onClick={() => refreshHistoryData()}>
                            <i class="fas fa-sync ml-2"></i>&nbsp; Refresh
                        </span>

                        <span
                            onClick={() => {
                                closeHistory();
                            }}
                            className="edit-icn-bx"
                        >
                            <i className="fas fa-info-circle"></i> View Details
                        </span>
                        <span
                            onClick={() => {
                                if (hasVerificationLogs) {
                                    if (tab === "energyStarRating" || tab === "Electricity" || tab === "Gas" || tab === "Water" || tab === "Sewer") {
                                        popBreadCrumpData();
                                        history.push(findPrevPathFromBreadCrumpData());
                                        popBreadCrumpData();
                                        return;
                                    }

                                    popBreadCrumpOnPageClose();
                                    history.push(findPrevPathFromBreadCrumpData() || "/dashboard");
                                } else closeHistory();
                            }}
                            className="edit-icn-bx"
                        >
                            <i className="fas fa-window-close"></i> Close
                        </span>

                        {hasEdit && (
                            <span
                                onClick={() => {
                                    editSurvey();
                                }}
                                className="edit-icn-bx"
                            >
                                <i className="fas fa-pencil-alt"></i> Edit
                            </span>
                        )}

                        {hasDelete && (
                            <span
                                onClick={() => {
                                    deleteSurveyTemplate();
                                }}
                                className="edit-icn-bx"
                            >
                                <i className="fas fa-trash-alt"></i> Delete
                            </span>
                        )}
                    </div>
                )}
                <div className="basic-dtl-otr">
                    <div className="dtl-sec col-md-12 log">
                        <div className="table-top-menu">
                            <div className="lft">
                                <h2>Activity Log</h2>
                            </div>
                            <div className="rgt">
                                <div className="search" id="search-global">
                                    <form id="serach-sec">
                                        <input
                                            type="search"
                                            placeholder="Search"
                                            onKeyPress={event => {
                                                if (event.key === "Enter") {
                                                    searchHandler(event);
                                                }
                                            }}
                                            onChange={event => {
                                                setSearchValue(event.target.value);
                                                if (!event.target.value.trim().length && params?.search) {
                                                    searchHandler(event);
                                                }
                                            }}
                                            value={searchValue}
                                        />
                                        <i
                                            className="fas fa-times"
                                            onClick={e => {
                                                setSearchValue("");
                                                if (params?.search) searchHandler({ target: { value: "" } });
                                            }}
                                        />
                                    </form>
                                </div>
                                {isMobileLog && (
                                    <div class="switcher-sm-chart ml-2">
                                        <label class="name-label">Mobile Log</label>
                                        <label
                                            class="switch toggle-switch mr-2"
                                            data-tip=""
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for="table-row1079f3b2-e33b-4273-9679-38566601b9c1"
                                            currentitem="false"
                                        >
                                            <input
                                                type="checkbox"
                                                onChange={() => {
                                                    setToggleBtn(!toggleBtn);
                                                    setParams({ ...params, offset: 0 });
                                                    setPaginationParams({ ...paginationParams, currentPage: 0 });
                                                }}
                                            />
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="tab-dtl region-mng  table-log-history-wrap">
                            <div className="tab-active buildng-tb">
                                <div className="table-section table-scroll build-table">
                                    <table className="table table-common">
                                        <thead>
                                            <tr>
                                                <th className="img-sq-box">
                                                    <img src="/img/bell.svg" />
                                                </th>
                                                <th className="build-code">All Logs</th>
                                                <th className="build-name cursor-pointer">Date and Time</th>
                                                {showActionColumn && <th className="type-dtl"> Action </th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {logData && logData && logData.length ? (
                                                <>
                                                    {logData.map((item, i) => (
                                                        <tr key={i}>
                                                            <td className="text-center">
                                                                <img src="/img/bell.svg" />
                                                            </td>
                                                            <td>
                                                                <ul>
                                                                    {(item?.event === "RECOMMENDATION_STATUS_UPDATES" || item?.event === "Restore") &&
                                                                    item?.notes &&
                                                                    Object.keys(safeParseJSON(item?.notes)?.old || {}).length > 0
                                                                        ? Object.keys(safeParseJSON(item?.notes).old || {}).map(key => (
                                                                              <>{renderSentence(item, searchValue, key, true)}</>
                                                                          ))
                                                                        : safeParseJSON(item?.notes)?.change?.length
                                                                          ? checklistChanges(item, searchValue)
                                                                          : Array.isArray(safeParseJSON(item?.notes)) &&
                                                                              safeParseJSON(item?.notes)?.length
                                                                            ? safeParseJSON(item?.notes)?.map(e => (
                                                                                  <li>
                                                                                      {renderSplitText(e)}{" "}
                                                                                      {!!item?.whodunnit_name && (
                                                                                          <>
                                                                                              {" by "}
                                                                                              {renderBoldText(item?.whodunnit_name)}
                                                                                          </>
                                                                                      )}
                                                                                  </li>
                                                                              ))
                                                                            : renderSentence(item, searchValue)}
                                                                </ul>
                                                            </td>
                                                            <td>
                                                                <div className="date">
                                                                    <span>{moment(item?.created_at)?.format("MM-DD-YYYY, hh:mm A")}</span>
                                                                </div>
                                                            </td>
                                                            {showActionColumn && (
                                                                <td className="type-dtl">
                                                                    {(hasRestore(item) || false) && (
                                                                        <li className="dropdown dot-icn-arw">
                                                                            <a
                                                                                className={`ref ${
                                                                                    item.event === "RESTORED" ? "cursor-disabled" : ""
                                                                                }`}
                                                                                onClick={() => {
                                                                                    if (item.event !== "RESTORED" && !isMobileRecommendation) {
                                                                                        restore_ref.current = true;
                                                                                        if (
                                                                                            item?.event === "RECOMMENDATION_STATUS_UPDATES" ||
                                                                                            item?.event === "Restore"
                                                                                        ) {
                                                                                            restoreLog(item.id, params);
                                                                                        } else {
                                                                                            dispatch(actions?.activityLogRestore(item.id));
                                                                                        }
                                                                                    }
                                                                                    if (isMobileRecommendation && item.event !== "RESTORED") {
                                                                                        restore_ref.current = true;
                                                                                        dispatch(
                                                                                            MobileAction?.MobileRecomactivityLogRestore(item.id)
                                                                                        );
                                                                                    }
                                                                                }}
                                                                                data-place="top"
                                                                                data-effect="solid"
                                                                                data-tip={item.event === "RESTORED" ? `Already restored` : "Restore"}
                                                                                data-background-color="#007bff"
                                                                            >
                                                                                <i
                                                                                    className={`fas fa-history cursor-hand" ${
                                                                                        item.event === "RESTORED" ? "cursor-disabled" : ""
                                                                                    }`}
                                                                                ></i>
                                                                            </a>
                                                                        </li>
                                                                    )}
                                                                </td>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </>
                                            ) : (
                                                <tr>
                                                    <td className="noRecordsColumn" colSpan={showActionColumn ? 4 : 3}>
                                                        No records found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {logData && logData.length ? (
                                    <div className="table-bottom d-flex">
                                        <div className="count d-flex col-md-6">
                                            <div className="count-dtl">
                                                Total Count: <span>{paginationParams?.totalCount}</span>
                                            </div>
                                            <div className="col-md-2 pr-2 selbx">
                                                <select
                                                    className="form-control"
                                                    value={paginationParams?.perPage}
                                                    onChange={e => handlePerPageChange(e)}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="20">20</option>
                                                    <option value="30">30</option>
                                                    <option value="40">40</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="pagination-sec col-md-6">
                                            <ReactPaginate
                                                previousLabel={
                                                    <span data-place="top" data-effect="solid" data-tip={`Previous`} data-background-color="#007bff">
                                                        &lt;
                                                    </span>
                                                }
                                                nextLabel={
                                                    <span data-place="top" data-effect="solid" data-tip={`Next`} data-background-color="#007bff">
                                                        &gt;
                                                    </span>
                                                }
                                                breakLabel={"..."}
                                                breakClassName={"break-me"}
                                                pageCount={paginationParams?.totalPages}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={5}
                                                containerClassName={"pagination"}
                                                subContainerClassName={"pages pagination"}
                                                activeClassName={"active"}
                                                activeLinkClassName={"active"}
                                                forcePage={paginationParams.currentPage}
                                                onPageChange={handlePageClick}
                                            />
                                            <ReactTooltip />
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <ReactTooltip /> */}
        </React.Fragment>
    );
};

export default EditHistory;
